<div class="dex-transfer-widget">
    <form [formGroup]="form" (ngSubmit)="onTransfer()" class="dex-transfer-form">

        <!-- From Wallet Selector -->
        <div class="dex-transfer-form-field">
            <label class="dex-transfer-form-label">
                {{'components.widgets.dex-transfer-widget.from_wallet' | l10n}}
            </label>
            <div class="dex-transfer-form-control -from">
                <dex-wallet-input
                    [class.-error]="form.hasError(WALLETS_MUST_BE_DIFFERENT_ERROR)"
                    [class.-submitted]="$isFormSubmitted()"
                    [formControl]="form.controls.from">
                </dex-wallet-input>
            </div>
        </div>

        <!-- To Wallet Input -->
        <div class="dex-transfer-form-field">
            <label class="dex-transfer-form-label">
                {{'components.widgets.dex-transfer-widget.to_wallet' | l10n}}
            </label>
            <div class="dex-transfer-form-control -to">
                <dex-wallet-input
                    [class.-error]="form.hasError(WALLETS_MUST_BE_DIFFERENT_ERROR)"
                    [class.-submitted]="$isFormSubmitted()"
                    [formControl]="form.controls.to"
                    [autocompleteConfig]="walletToAutocompleteConfig">
                </dex-wallet-input>
            </div>
        </div>

        <!-- Asset Input -->
        <div class="dex-transfer-form-field">
            <label class="dex-transfer-form-label">
                {{'components.widgets.dex-transfer-widget.asset' | l10n}}
            </label>
            <div class="dex-transfer-form-control">
                <deliverable-input
                    [formControl]="form.controls.asset"
                    [autocompleteConfig]="deliverableAutocompleteConfig">
                </deliverable-input>
            </div>
        </div>

        <!-- Amount Input -->
        <div class="dex-transfer-form-field">
            <label class="dex-transfer-form-label">
                {{'components.widgets.dex-transfer-widget.amount' | l10n}}
            </label>
            <div class="dex-transfer-form-control">
                <decimal-input-wrapper>
                    <input type="text"
                           [formControl]="form.controls.qty"
                           [decimal]="$safeNavigationMigration(form.controls.asset.value?.decimalPlaces)"
                           [min]="$safeNavigationMigration(form.controls.asset.value?.decimalPlaces) | delMinQty"
                           [step]="$safeNavigationMigration(form.controls.asset.value?.decimalPlaces) | delMinQty"
                           decimalInput
                           class="dex-transfer-input">
                    </decimal-input-wrapper>
            </div>
        </div>

        <!-- Available -->
        <div class="dex-transfer-form-field">
            <label class="dex-transfer-form-label">
                {{'components.widgets.dex-transfer-widget.available' | l10n}}
            </label>
            <div class="dex-transfer-form-control">
                @let balance = balance$ | async;
                <span
                    class="-balance-link"
                    (click)="onSetQuickAmount($event, balance)"
                    [displayDecimal]="$safeNavigationMigration(balance?.balance) | bigintDeliverableDisplayDecimal:$safeNavigationMigration(balance?.deliverable)" [dashIfEmpty]="true">
                </span>
            </div>
        </div>

        <!-- Transfer Button -->
        <div class="dex-transfer-form-actions">
            <button type="submit"
                    class="dex-transfer-button"
                    [disabled]="$isTransferring()">
                @if (!$isTransferring()) {
                    <span>
                        {{'components.widgets.dex-transfer-widget.transfer' | l10n}}
                    </span>
                }
                @if ($isTransferring()) {
                    <span>
                        {{'components.widgets.dex-transfer-widget.transferring' | l10n}}...
                    </span>
                }
            </button>
        </div>

        <!-- Error Message -->
        @if ($transferError()) {
            <div class="dex-transfer-message -error">
                @let err = $transferError();
                @if (err.dexTxError?.naming) {
                    {{err.dexTxError.naming.msg | l10n}}
                    @if (err.dexTxError.naming.msgLong) {
                        <span class="-i" [tooltipL10n]="err.dexTxError.naming.msgLong">ⓘ</span>
                    }
                } @else if (err.dexTxError?.details?.name) {
                    {{err.dexTxError.details.name}}
                } @else {
                    {{err.message}}
                }
            </div>
        }

        <!-- Success Message -->
        @if ($transferSuccess()) {
            <div class="dex-transfer-message -success">
                <div class="dex-transfer-success-content">
                    <div>{{'components.widgets.dex-transfer-widget.transfer_success' | l10n}}</div>
                    @let hash = $transactionHash();
                    @if (hash) {
                        <div class="dex-transfer-tx-details">
                            {{'components.widgets.dex-transfer-widget.transaction_hash' | l10n}}: <span [copyTooltip]="hash">{{hash | shortenWalletAddr}}</span>
                        </div>
                    }
                    @if ($transactionLink()) {
                        <div class="dex-transfer-tx-details">
                            <a [href]="$transactionLink()" target="_blank" rel="noopener noreferrer">
                                {{'components.widgets.dex-transfer-widget.view_on_explorer' | l10n}}
                            </a>
                        </div>
                    }
                </div>
            </div>
        }

    </form>
</div>
